export const API_CONFIRM_SOUND = "kron.tm3.service-web-1.0/webresources/restservice/event/confirm-sound";

export const rowClassEvent = function (data) {
  switch (data.event_group_index) {
    case 1:
      return "row-accessories-yellow";
    case 3:
      return "row-accessories-red";
    case 4:
      return "row-accessories-orange"
    default:
      return "row-accessories-green";
  }
};

export const rowClassLog = function (data) {
  switch (data.command_result) {
    case false:
      return "row-accessories-yellow";
    case true:
      return "row-accessories-green";

  }
  return "row-accessories-red";
};

export const getToolbarFilters = (routeParams) => {
  return [
    {
      name: "periods",
      enabled: true,
      required: false,
      default: "Текущий день",
      attrList: { date_begin: { selectOtherMonths: true }, date_end: { selectOtherMonths: true } },
    },
    {
      name: "facility",
      enabled: true,
      required: false,
      default: Number(routeParams.facility_id),
      attrList: { disabled: true, },
    },
  ];
};
export const EVENT_DATA_DICTIONARY = [
  /*{
    options: "flange",
    save: { store: false, self: true },
    load: "self",
    keyName: "flange_no",
    valueName: "flange_no",
  },*/
  {
    options: "event_category",
    save: { store: false, self: true },
    load: "self",
    keyName: "event_category_name",
    valueName: "event_category_name",
  },
  {
    options: "event_type",
    save: { store: false, self: true },
    load: "self",
    keyName: "event_type_name",
    valueName: "event_type_name",
  },
  {
    options: "result",
    save: { store: false, self: true },
    load: "parent",
    data() {
      return [
        { ["name"]: "Ошибка", id: 0 },
        { ["name"]: "Успешно", id: 1 },
      ];
    },
  },
];
export const EVENT_DATA_COLUMNS = [
  {
    header: "Группа",
    field: "event_group_index",
    dataType: "image",
    image: [51, 54, 51, 53, 52],
    sortable: true,
    bodyStyle: "text-align: center;  width:100px",
  },
  {
    header: "Тип",
    field: "facility_type_name",
    sortable: true,
  },
  {
    header: "Объект",
    field: "facility_name",
    sortable: true,
  },
  {
    header: "Фл(ус)",
    field: "flange_no",
    bodyStyle: "text-align: center; width:60px",
    sortable: true,
    filterData: {
      type: "InputText",
      "max-width": "60px",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: "Категория",
    field: "event_category_name",
    sortable: true,
    filterData: {
      options: "event_category",
      type: "MultiSelect",
      filter: true,
      mode: "in",
      valueName: "event_category_name",
    },
  },
  {
    header: "Событие",
    field: "event_type_name",
    sortable: true,
    filterData: {
      options: "event_type",
      type: "MultiSelect",
      filter: true,
      mode: "in",
      valueName: "event_type_name",
    },
  },
  {
    header: "Дата события",
    dataType: "date-time-gmt",
    conversion: true,
    headerStyle: "width: 140px",
    field: "event_date",
    sortable: true,
  },
  {
    header: "Знач",
    field: "property_value",
    bodyStyle: "text-align: right;",
    sortable: true,
    columnType: 'numeric',
    showFilterMenu: true,
    filterData: {
      type: "InputNumber",
      "max-width": "70px",
      attrList: { mode: "decimal", step: 0.01, showButtons: true },
    },
  },
  {
    header: "Свойство",
    field: "property_type_name",
    sortable: true,
  },
  {
    header: "K",
    field: "event_confirm",
    dataType: "check-box",
    headerStyle: "width: 1rem",
    bodyStyle: "text-align: center;overflow: visible",
    configComponent: {
      name: "i",
      iconTrue: "pi pi-pencil",
      iconFalse: "pi pi-trash",
      classTrue: "pi true-icon pi-check-circle",
      classFalse: "pi false-icon pi-times-circle",
      componentFunction: () => { },
    },
  },
  {
    header: "Дата квитирования",
    field: "event_date_confirm",
    dataType: "date-time",
    conversion: true,
    headerStyle: "width: 150px",
  },
];
export const COMMAND_LOG_COLUMNS = [
  {
    header: "PID",
    field: "property_id",
    sortable: true,
  },
  {
    header: "FID",
    field: "facility_id",
    sortable: true,
  },
  {
    header: "Дата события",
    dataType: "date-time-gmt",
    conversion: true,
    headerStyle: "width: 140px",
    field: "command_date",
    sortable: true,
  },
  {
    header: "Пользователь",
    field: "user_name",
    sortable: true,
  },
  {
    header: "Свойство",
    field: "property_type_name",
    sortable: true,
  },
  {
    header: "Текущее значение",
    field: "property_value",
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Записываемое значение",
    field: "property_write_value",
    sortable: true,
    bodyStyle: "text-align: right;",
  },
  {
    header: "Результат",
    field: "command_result",
    dataType: "image",
    image: [54, 51],
    sortable: true,
    bodyStyle: "text-align: center;",
  },
];
export const ACTIVE_EVENT_COLUMNS = [
  {
    header: "Группа",
    field: "event_group_index",
    dataType: "image",
    image: [51, 54, 51, 53, 52],
    sortable: true,
    bodyStyle: "text-align: center;  width:100px",
  },
  {
    header: "Дата",
    dataType: "date-time",
    headerStyle: "width: 160px",
    field: "date",
    sortable: true,
  },
  {
    header: 'Объект',
    field: 'facilityName',
    sortable: true,
    filterData: {
      type: "InputText",
      "max-width": "250px",
    },
  },
  {
    header: 'Фланец',
    field: 'flangeNo',
    sortable: true,
    bodyStyle: "text-align: right;",
    headerStyle: "width: 120px",
    filterData: {
      type: "InputText",
      "max-width": "60px",
      attrList: { type: "number", step: "1" },
    },
  },
  {
    header: 'Скв',
    field: 'wellName',
    sortable: true,
    filterData: {
      type: "InputText",
      "max-width": "250px",
    },
  },
  {
    header: 'Категория',
    field: 'eventCategoryName',
    sortable: true,
    filterData: {
      options: "eventCategoryNames",
      type: "MultiSelect",
      mode: "in",
      "max-width": "280px",
    },
  },
  {
    header: 'Событие',
    field: 'eventTypeName',
    sortable: true,
    filterData: {
      options: "eventTypeNames",
      type: "MultiSelect",
      mode: "in",
      "max-width": "280px",
    },
  },
  {
    header: 'Описание',
    field: 'propertyDesc',
    sortable: true,
  },

  {
    header: 'Оповещение',
    field: 'shouldPlaySound',
    sortable: true,
    dataType: "check-box",
    headerStyle: "width: 130px",
    bodyStyle: "text-align: center;overflow: visible",
    hint: "textForSoundReproduction",
    configComponent: {
      name: "i",
      iconTrue: "pi pi-pencil",
      iconFalse: "pi pi-trash",
      classTrue: "pi true-icon pi-check-circle",
      classFalse: "pi false-icon pi-times-circle",
      componentFunction: () => { },
    },
    filterData: {
      type: "Dropdown",
      "max-width": "150px",
      attrList: {
        optionLabel: "name",
        optionValue: "id",
        options: [
          { ["name"]: "Не активно", id: false },
          { ["name"]: "Активно", id: true },]
      },

    },
  }
];
export const ACTIVE_EVENT_FILTER = {
  flangeNo: { "value": null, "matchMode": "contains" }
};

export const EVENT_CONFIRM_SOUND_TOOLBAR_FILTERS = [
  {
    name: "periods",
    enabled: true,
    required: true,
    attrList: { showTime: true, date_begin: { selectOtherMonths: true }, date_end: { selectOtherMonths: true } },
    default: "Текущий день",
  },
];
export const EVENT_CONFIRM_SOUND_COLUMNS = [
  {
    header: 'ID',
    field: 'event_confirm_sound_id',
    sortable: true,
    filterData: {
      type: "InputNumber",
      "max-width": "90px",
      attrList: { mode: "decimal", step: 1, },
    },
  },
  {
    header: 'Объект',
    field: 'facility_name',
    sortable: true,
    filterData: {
      type: "InputText",
    },
  },
  {
    header: 'Фл.',
    field: 'flange_no',
    sortable: true,
    filterData: {
      type: "InputNumber",
      "max-width": "80px",
      attrList: { mode: "decimal", step: 1, },
    },
  },
  {
    header: 'Свойство',
    field: 'property_type_name',
    sortable: true,
    filterData: {
      type: "InputText",
    },
  },
  {
    header: 'Событие',
    field: 'event_type_name',
    sortable: true,
    filterData: {
      type: "InputText",
    },
  },
  {
    header: 'Дата события',
    field: 'event_date',
    sortable: true,
    dataType: 'date-time-gmt',
    conversion: true,
    headerStyle: 'width: 140px',
    filterData: {
      type: 'Calendar',
      mode: 'dateIsGMT',
      attrList: { dateFormat: 'dd.mm.yy' },
    },
  },
  {
    header: 'Логин',
    field: 'user_name',
    sortable: true,
    filterData: {
      type: "InputText",
    },
  },
  {
    header: 'ФИО',
    field: 'user_struct_name',
    sortable: true,
    filterData: {
      type: "InputText",
    },
  },
  {
    header: 'Причина',
    field: 'event_confirm_reason',
    sortable: true,
    filterData: {
      type: "InputText",
    },
  },
  {
    header: 'Дата квитирования',
    field: 'event_confirm_sound_date',
    sortable: true,
    dataType: 'date-time-gmt',
    conversion: true,
    headerStyle: 'width: 140px',
    filterData: {
      type: 'Calendar',
      mode: 'dateIsGMT',
      attrList: { dateFormat: 'dd.mm.yy' },
    },
  },
];